export const TOGGLE_ACCORDION = "TOGGLE_ACCORDION";
export const SUMMARY_RAIL_SPINNER = "SUMMARY_RAIL_SPINNER";
export const APPLY_COUPON_BTN_SPINNER = "APPLY_COUPON_BTN_SPINNER"
export const RESET_COUPON_RESPONSE_MSG = "RESET_COUPON_RESPONSE_MSG";
export const RESET_PROMOTION_ID_RESPONSE_MSG = "RESET_PROMOTION_ID_RESPONSE_MSG";
